export default __webpack_public_path__ + "static/pulzion18-e133e379393b7d4af3fc65472cb9bcdd.png";